module.exports = __webpack_public_path__ + "img/Billboard3.fbf7fa16.jpg";